import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Home, ChevronLeft, RotateCw } from 'lucide-react';

/**
 * NavStrip — slim top utility bar with Home / Back / Refresh on every page.
 * Hidden on auth pages (Login, Signup, AuthCallback) since they have their own minimal layout.
 */
const NavStrip = () => {
  const nav = useNavigate();
  const loc = useLocation();
  const hidden = ['/login', '/signup', '/auth/callback'].some((p) => loc.pathname.startsWith(p));
  if (hidden) return null;

  return (
    <div
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-slate-200 px-3 sm:px-4"
      data-testid="nav-strip"
    >
      <div className="max-w-7xl mx-auto h-9 flex items-center gap-1">
        <button
          onClick={() => nav(-1)}
          className="inline-flex items-center gap-1 h-7 px-2 rounded-md text-xs font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100"
          data-testid="nav-back-btn"
          title="Back"
        >
          <ChevronLeft className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Back</span>
        </button>
        <Link
          to="/"
          className="inline-flex items-center gap-1 h-7 px-2 rounded-md text-xs font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100"
          data-testid="nav-home-btn"
          title="Home"
        >
          <Home className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Home</span>
        </Link>
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-1 h-7 px-2 rounded-md text-xs font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100"
          data-testid="nav-refresh-btn"
          title="Refresh"
        >
          <RotateCw className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Refresh</span>
        </button>
        <span className="ml-auto text-[10px] text-slate-400 font-mono truncate max-w-[180px] sm:max-w-xs">
          {loc.pathname}
        </span>
      </div>
    </div>
  );
};

export default NavStrip;
